<template>
  <div class="col-md-3 col-sm-6 col-12">
    <div class="info-box">
      <span class="info-box-icon bg-warning"><i class="far fa-comment-dots"></i></span>

      <div class="info-box-content">
        <span class="info-box-text text-bold">General Tickets</span>
        <span class="info-box-number text-bold">{{ GeneralTickets }}</span>
      </div>
      <!-- /.info-box-content -->
    </div>
    <!-- /.info-box -->
  </div>
</template>

<script>
export default {
    name: 'ticket-counter-general',
  data() {
    return {
      GeneralTickets: 0,
    };
  },
};
</script>

<style lang="scss" scoped>
</style>